import PropTypes from 'prop-types';

/**
 * Throws a route-level error during render so the nearest error boundary catches it.
 * Used when found-relay surfaces a network error for the route query.
 * @param {object} props - Component props.
 * @param {Error} props.error - The error to throw.
 */
function RouteErrorThrower({ error }) {
  throw error;
}

RouteErrorThrower.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
};

export default RouteErrorThrower;
